import React, { forwardRef } from 'react';
import useLocalization from 'localization';
import withHover from '../../hocs/withHover';
import withFocus from '../../hocs/withFocus';
import useTheme from 'branding/theme';
const resetButtonStyles = {
    border: 'none',
    backgroundColor: 'rgba(0,0,0,0)',
    padding: 0
};
export const ClickableOpacity = forwardRef(({ children, alt, type = 'button', fullWidth = false, disabled = false, className, styles, isHovered, isFocused, handleMouseEnter, handleMouseLeave, handleFocus, handleBlur, ...rest }, ref) => {
    const { t } = useLocalization();
    const { utility: { size: fullWidthStyles } } = useTheme();
    const altText = typeof children === 'number' ? String(children) : alt && t(alt);
    const mergedStyles = {
        ...resetButtonStyles,
        ...(fullWidth && fullWidthStyles.fullWidthStyles),
        ...(disabled && { cursor: 'not-allowed' }),
        ...(isHovered && { cursor: 'pointer' }),
        ...styles
    };
    return (React.createElement("button", { title: altText, style: mergedStyles, type: type, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: handleFocus, onBlur: handleBlur, disabled: disabled, className: className, ref: ref, ...rest }, typeof children === 'string' ? t(String(children)) : children));
});
export default withHover(withFocus(ClickableOpacity));
//# sourceMappingURL=index.js.map